{
  "name": "insecta-ui",
  "version": "3.6.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "gettoken": "vsts-npm-auth -c .npmrc",
    "generate-component": "ng generate component --skip-tests=true component-name",
    "build-ci": "ng build --verbose",
    "prune": "git fetch origin --prune",
    "lint": "eslint",
    "lint:fix": "eslint --fix",
    "prettier:fix": "npx prettier --write .",
    "dotnet-drop-db": "dotnet ef database drop",
    "dotnet-update-db": "dotnet ef database update",
    "dotnet-add-migration": "dotnet ef migrations add [Migration-Name]"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.0",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@azure/msal-angular": "^3.0.23",
    "@azure/msal-browser": "^3.21.0",
    "@corteva-research/ngx-components-core": "^3.0.2",
    "@corteva-research/ngx-components-msal-integration": "^3.0.0-rc.20240612.1",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@fullcalendar/angular": "^6.1.18",
    "@fullcalendar/daygrid": "^6.1.18",
    "@fullcalendar/interaction": "^6.1.18",
    "@microsoft/applicationinsights-web": "^3.3.6",
    "@primeng/themes": "^18.0.2",
    "lodash-es": "^4.17.21",
    "pdfmake": "^0.2.20",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^18.0.2",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1802.0",
    "@angular-devkit/build-angular": "^18.2.0",
    "@angular-devkit/core": "^18.2.0",
    "@angular-devkit/schematics": "^18.2.0",
    "@angular/cli": "^18.2.0",
    "@angular/compiler-cli": "^18.2.0",
    "@eslint/js": "^9.22.0",
    "@schematics/angular": "^18.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash-es": "^4.17.12",
    "@types/pdfmake": "^0.2.11",
    "@types/tinycolor2": "^1.4.6",
    "eslint": "^9.22.0",
    "globals": "^16.0.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "3.5.3",
    "typescript": "~5.5.2",
    "typescript-eslint": "^8.26.1"
  }
}
